import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GA_MEASUREMENT_ID } from '../config/analytics';
import { useCookieConsent } from '../context/CookieConsentContext';
import {
  initGoogleAnalytics,
  setGoogleAnalyticsConsent,
  trackGoogleAnalyticsPageView,
} from '../utils/googleAnalytics';

export default function GoogleAnalytics() {
  const { isCategoryEnabled, preferences } = useCookieConsent();
  const location = useLocation();
  const analyticsEnabled = isCategoryEnabled('analytics');

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    initGoogleAnalytics(GA_MEASUREMENT_ID);
  }, []);

  useEffect(() => {
    if (!GA_MEASUREMENT_ID || preferences === null) return;
    setGoogleAnalyticsConsent(analyticsEnabled);
  }, [analyticsEnabled, preferences]);

  useEffect(() => {
    if (!GA_MEASUREMENT_ID || !analyticsEnabled) return;

    trackGoogleAnalyticsPageView(
      GA_MEASUREMENT_ID,
      `${location.pathname}${location.search}`,
    );
  }, [analyticsEnabled, location.pathname, location.search]);

  return null;
}
